import { getRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getIraSettings = (accountUid) =>
  getRequest(
    replaceInUrl(apiEndpoints.accounts.getIraSettings, { accountUid }),
  );
